import { GET_CMS_BLOCKS } from './getCmsBlocks';
import { GET_CMS_PAGE } from './getCmsPage';
import { GET_BACKEND_CONFIG, GET_SHOP_CONFIG } from './getBackendConfig';

export { GET_CMS_BLOCKS, GET_CMS_PAGE, GET_BACKEND_CONFIG, GET_SHOP_CONFIG };
